import React from 'react'
import Table from 'src/_metronic/layout/components/table/Table'

interface MyTasksTableProps {
  accounts: any[]
  sortColumn: string
  onSort: (column: string) => void
  newColumns: any[]
  setSelectedRows: any
  selectedRows: any
  handleRowClick: any
  tableRef: any
  loading: boolean
  handleSelectAll: any
}

const MyTasksTable: React.FC<MyTasksTableProps> = ({
  accounts,
  sortColumn,
  onSort,
  newColumns,
  setSelectedRows,
  selectedRows,
  handleRowClick,
  tableRef,
  loading,
  handleSelectAll,
}) => {
  return (
    <Table
      data={accounts}
      columns={newColumns}
      sortColumn={sortColumn}
      onSort={onSort}
      checkBox={false}
      setSelectedRows={setSelectedRows}
      selectedRows={selectedRows}
      tableRef={tableRef}
      loading={loading}
      handleSelectAll={handleSelectAll}
      handleRowClick={handleRowClick}
    />
  )
}

export default MyTasksTable
